import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  inject,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  PermissionFeature,
  PermissionService,
} from '@price-management-console/permissions';
import { Tab } from '@price-management-console/shared-ui';

@Component({
  selector: 'app-home',
  imports: [CommonModule, TranslateModule],
  templateUrl: './home.html',
  styleUrl: './home.css',
  encapsulation: ViewEncapsulation.None,
})
export class Home {
  private readonly router = inject(Router);
  private readonly permissions = inject(PermissionService);
  @Output() tabChange = new EventEmitter<void>();

  tabs = computed<Tab[]>(() => {
    const hasAccess = this.permissions.hasFeatureAccess(
      PermissionFeature.RoutingProtocol
    );
    return [
      {
        label: 'ROUTING_PROTOCOL.ROUTING_PROTOCOLS',
        disabled: !hasAccess,
        path: 'protocols',
      },
      {
        label: 'ROUTING_PROTOCOL.PROTOCOL_GROUPS',
        disabled: !hasAccess,
        path: 'groups',
      },
      {
        label: 'ROUTING_PROTOCOL.STATIONS',
        disabled: !hasAccess,
        path: 'stations',
      },
      {
        label: 'ROUTING_PROTOCOL.EXCEPTIONS',
        disabled: !hasAccess,
        path: 'exceptions',
      },
      {
        label: 'ROUTING_PROTOCOL.JUNCTION_SYNONYMS',
        disabled: !hasAccess,
        path: 'junction-synonyms',
      },
    ];
  });

  changeTab(index: number) {
    if (this.tabs()[index].disabled) {
      return;
    }

    this.router.navigate(['/routing-protocol', this.tabs()[index].path]);
  }
}
